/**
 *
 * Asynchronously loads the component for DailyReportPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const DailyReportPage = lazyLoad(
  () => import('./index'),
  module => module.DailyReportPage,
);
